import { ExpenseData } from "../models/expenses/ExpenseData";
export const GetNewExpenseId = (): number => {
  const maxId = Math.max(...DemoExpenses.map((expense) => expense.id), 0);
  return maxId + 1;
};
export const DemoExpenses: ExpenseData[] = [
  {
    id: 1,
    cost: 50.25,
    category: "Groceries",
    description: "Monthly grocery shopping",
    date: new Date("2022-02-15"),
  },
  {
    id: 2,
    cost: 30.0,
    category: "Utilities",
    description: "Electricity bill",
    date: new Date("2022-03-10"),
  },
  {
    id: 3,
    cost: 20.5,
    category: "Transportation",
    description: "Gas for the car",
    date: new Date("2022-04-05"),
  },
  {
    id: 4,
    cost: 80.0,
    category: "Healthcare",
    description: "Doctor appointment",
    date: new Date("2022-05-20"),
  },
  {
    id: 5,
    cost: 15.99,
    category: "Entertainment",
    description: "Movie night",
    date: new Date("2022-06-08"),
  },
  {
    id: 6,
    cost: 45.5,
    category: "Clothing",
    description: "New pair of shoes",
    date: new Date("2022-07-15"),
  },
  {
    id: 7,
    cost: 200.0,
    category: "Travel",
    description: "Weekend getaway",
    date: new Date("2022-08-22"),
  },
  {
    id: 8,
    cost: 10.0,
    category: "Other",
    description: "Miscellaneous expense",
    date: new Date("2022-09-12"),
  },
  {
    id: 9,
    cost: 55.5,
    category: "Groceries",
    description: "Weekly grocery shopping",
    date: new Date("2023-01-05"),
  },
  {
    id: 10,
    cost: 35.0,
    category: "Utilities",
    description: "Water bill",
    date: new Date("2023-02-18"),
  },
  {
    id: 11,
    cost: 25.75,
    category: "Transportation",
    description: "Public transportation pass",
    date: new Date("2023-03-25"),
  },
  {
    id: 12,
    cost: 90.0,
    category: "Healthcare",
    description: "Dental checkup",
    date: new Date("2023-04-12"),
  },
  {
    id: 13,
    cost: 18.99,
    category: "Entertainment",
    description: "Concert tickets",
    date: new Date("2023-05-30"),
  },
  {
    id: 14,
    cost: 50.2,
    category: "Clothing",
    description: "Summer wardrobe update",
    date: new Date("2023-06-15"),
  },
  {
    id: 15,
    cost: 250.0,
    category: "Travel",
    description: "Vacation expenses",
    date: new Date("2023-08-10"),
  },
  {
    id: 16,
    cost: 12.5,
    category: "Other",
    description: "Unexpected expense",
    date: new Date("2023-09-28"),
  },
  {
    id: 17,
    cost: 60.75,
    category: "Groceries",
    description: "Special occasion grocery shopping",
    date: new Date("2024-01-14"),
  },
  {
    id: 18,
    cost: 40.0,
    category: "Utilities",
    description: "Internet bill",
    date: new Date("2024-01-08"),
  },
  {
    id: 19,
    cost: 30.25,
    category: "Transportation",
    description: "Car maintenance",
    date: new Date("2024-02-20"),
  },
  {
    id: 20,
    cost: 100.0,
    category: "Healthcare",
    description: "Prescription medications",
    date: new Date("2024-02-05"),
  },
  {
    id: 21,
    cost: 25.99,
    category: "Entertainment",
    description: "Streaming service subscription",
    date: new Date("2024-01-12"),
  },
  {
    id: 22,
    cost: 55.0,
    category: "Clothing",
    description: "Winter clothing purchase",
    date: new Date("2024-01-02"),
  },
  {
    id: 23,
    cost: 300.0,
    category: "Travel",
    description: "International trip expenses",
    date: new Date("2024-01-18"),
  },
  {
    id: 24,
    cost: 15.5,
    category: "Other",
    description: "Gift for a friend",
    date: new Date("2024-01-30"),
  },
  {
    id: 25,
    cost: 40.5,
    category: "Groceries",
    description: "Weekly grocery shopping",
    date: new Date("2024-02-05"),
  },
  {
    id: 26,
    cost: 25.0,
    category: "Utilities",
    description: "Gas bill",
    date: new Date("2024-02-10"),
  },
  {
    id: 27,
    cost: 15.75,
    category: "Transportation",
    description: "Bus tickets",
    date: new Date("2024-02-15"),
  },
  {
    id: 28,
    cost: 60.0,
    category: "Healthcare",
    description: "Pharmacy expenses",
    date: new Date("2024-02-20"),
  },
  {
    id: 29,
    cost: 12.99,
    category: "Entertainment",
    description: "Book purchase",
    date: new Date("2024-02-08"),
  },
  {
    id: 30,
    cost: 35.2,
    category: "Clothing",
    description: "New shirt",
    date: new Date("2024-02-18"),
  },
  {
    id: 31,
    cost: 120.0,
    category: "Travel",
    description: "Planning a future trip",
    date: new Date("2024-02-22"),
  },
  {
    id: 32,
    cost: 8.5,
    category: "Other",
    description: "Coffee with friends",
    date: new Date("2024-02-12"),
  },
  {
    id: 33,
    cost: 40.5,
    category: "Groceries",
    description: "Weekly grocery shopping",
    date: new Date("2024-03-01"),
  },
  {
    id: 34,
    cost: 25.0,
    category: "Utilities",
    description: "Gas bill",
    date: new Date("2024-03-01"),
  },
  {
    id: 35,
    cost: 15.75,
    category: "Transportation",
    description: "Bus tickets",
    date: new Date("2024-03-01"),
  },
];
